<div class="content layout horizontal center middle" 
     style="width: 100%;"
     [ngStyle]="{'min-height': (canvasLayoutDataService.viewportHeight-canvasLayoutDataService.headerHeight-40)+'px'}">
     <div [ngStyle]="{'width': isLesserThanXs ? '300px'
                       : (isGreaterThanXxs && isLesserThanM) ? '500px'
                       : '500px'}">
          <img [src]="frontImage" style="width: 100%;">
          <div style="width: 100%; margin-top: 20px;" class="layout horizontal space-between middle">
               <div class="subtitle">BACKOFFICE</div>
               <app-button *ngIf="securityDataService.cookiePolicyAccepted()" 
                 label="ACCEDI" 
                 primary="true" 
                 (click)="accedi()"
                 [settings]="{bgColor: Color.main}"></app-button>
          </div>
     </div>
</div>